import { registerLocaleData } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import localeEn from "@angular/common/locales/en";
import localeFr from "@angular/common/locales/fr";
import { LOCALE_ID, NgModule } from "@angular/core";
import { TranslateLoader, TranslateModule, TranslateService } from "@ngx-translate/core";
import { LanguageService } from "@shared/services/language.service";
import { SessionService } from "@shared/services/session.service";
import { CustomI18nTranslateLoader } from "./customI18nLoader";

// Register ALL locales your app may use
registerLocaleData(localeFr);
registerLocaleData(localeEn);
@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomI18nTranslateLoader,
        deps: [LanguageService],
      },
    }),
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: (sessionService: SessionService, translateService: TranslateService): string => {
        const lang = sessionService.userLang || translateService.getBrowserLang() || "en";
        return langToLocale(lang);
      },
      deps: [SessionService, TranslateService],
    },
  ],
  exports: [TranslateModule],
})
export class CommonTranslateModule {
  // Do not include a constructor in a module; otherwise, it will short-circuit Angular's initialization flow at the initialization stage.
}

function langToLocale(lang: string): string {
  const map: Record<string, string> = {
    fr: "fr-FR",
    en: "en-US",
  };
  return map[lang] ?? "en-US";
}
